import { Locale, Translation } from 'locale'
import React from 'react'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { ModalFooter } from 'view/components/panels'
import { HorizontalLayout } from 'view/styles/constants'

interface MappingDialogFooter {
  handleClose: () => void
  handleSave: () => void
  canSave: boolean
}

export const MappingDialogFooter: React.FC<MappingDialogFooter> = props => {
  const { handleClose, handleSave, canSave } = props
  return (
    <ModalFooter horizontalLayout={HorizontalLayout.SpaceBetween}>
      <TextButton dataTestId={'MappingDialog-TextButton-ButtonCancel'} type={TextButtonType.Tertiary} onClick={handleClose}>
        {Locale.translate(Translation.TC_BUTTON_CANCEL)}
      </TextButton>
      <TextButton dataTestId={'MappingDialog-TextButton-ButtonSave'} type={TextButtonType.Primary} disabled={!canSave} onClick={handleSave}>
        {Locale.translate(Translation.TC_BUTTON_SAVE)}
      </TextButton>
    </ModalFooter>
  )
}
